<!-- Copyright 2022, Common Good Learning Tools LLC -->
<template><div v-if="item">
	<button type="button" class="k-case-tree-item-tile-full-screen-overlay" aria-hidden="true" tabindex="-1" @click="hide_expanded_item"></button>
	<div
		ref="expandedTileDialog"
		class="k-case-tree-item-tile-full-screen-dialog"
		role="dialog"
		aria-modal="true"
		:aria-label="expanded_dialog_label"
		tabindex="-1"
	>
		<CASEItemTile :home_framework_record="framework_record" :item="item" :item_framework_record="item_framework_record" :viewer="viewer" :expanded_tile="true" @full_screen_compressed="hide_expanded_item" @more_info="more_info(item)" />
	</div>
	<div class="k-case-tree-item-tile-full-screen-history">
		<k-btn :disabled="history_pointer==0" icon small color="#666" accessible-label="Show previous expanded item" @click="move_via_history(-1)" class="mr-0"><k-icon>fas fa-circle-arrow-left</k-icon></k-btn>
		<k-btn :disabled='history_pointer==(history.length-1)' icon small color="#666" accessible-label="Show next expanded item" @click="move_via_history(1)" class="ml-0"><k-icon>fas fa-circle-arrow-right</k-icon></k-btn>
	</div>
</div></template>

<script>
import { mapState, mapGetters } from 'vuex'
import CASEItemTile from './CASEItemTile'
import { accessible_modal_mixin } from '@cglt/ui-legacy'

export default {
	mixins: [accessible_modal_mixin],
	components: { CASEItemTile },
	props: {
		// item: { required: true },
		// the received framework_record here is the "home" framework that the user is viewing; we may show a tile for an item from an associated framework
		framework_record: { required: true },
		viewer: { required: true },
	},
	data() { return {
		item: null,
		item_framework_record: null,
		history: [],
		history_pointer: -1,
	}},
	computed: {
		...mapState([]),
		...mapGetters([]),
		expanded_dialog_label() {
			const title = this.item?.cfitem?.fullStatement || this.item?.cfitem?.title || this.item?.cfitem?.humanCodingScheme || 'item'
			return `Expanded item view for ${title}`
		},
	},
	watch: {
		item() {

		}
	},
	created() {
	},
	mounted() {
	},
	methods: {
		accessible_modal_is_open() {
			return Boolean(this.item)
		},
		get_accessible_modal_container() {
			return this.$refs.expandedTileDialog || null
		},
		get_accessible_modal_initial_focus_selector() {
			return '.k-case-tree-item-tile-close-btn, button:not([tabindex="-1"]), [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
		},
		show_item(item, item_framework_record) {
			const was_closed = !this.item
			if (was_closed) this.capture_accessible_modal_focus_origin()

			this.item = item
			this.item_framework_record = item_framework_record

			// push new item to history, unless this is the current item in history
			let last = this.history[this.history_pointer]
			if (!last || last.item.cfitem.identifier != item.cfitem.identifier) {
				// if history_pointer wasn't already at the end of history, delete everything beyond history_pointer
				if (last && this.history_pointer != this.history.length-1) {
					this.history.splice(this.history_pointer+1, 100000)
				}

				this.history.push({item:item, item_framework_record:item_framework_record})
				this.history_pointer = this.history.length-1
			}

			if (was_closed) this.register_accessible_modal()
			this.focus_accessible_modal_content()
		},

		move_via_history(delta) {
			this.history_pointer += delta
			this.item = this.history[this.history_pointer].item
			this.item_framework_record = this.history[this.history_pointer].item_framework_record
		},

		hide() {
			const was_open = Boolean(this.item)
			this.item = null
			this.item_framework_record = null
			if (was_open) {
				this.unregister_accessible_modal()
				this.restore_accessible_modal_focus_origin()
			}
		},

		hide_expanded_item() {
			this.viewer.hide_expanded_item()
		},

		more_info() {
			this.viewer.more_info(this.item)
		},
		close_accessible_modal_from_escape() {
			this.hide_expanded_item()
		}
	}
}
</script>

<style lang="scss">
.k-case-tree-item-tile-full-screen-overlay {
	position:fixed;
	z-index:198;
	left:0;
	top:0;
	width:100vw;
	height:100vh;
	background-color:rgba(0,0,0,0.3);
	cursor:pointer;
	border:0;
	padding:0;
}

.k-case-tree-item-tile-full-screen-dialog {
	position: fixed;
	z-index: 199;
	inset: 0;
	pointer-events: none;

	.k-case-tree-item-tile-outer-full-screen,
	.k-case-tree-item-tile-outer-full-screen * {
		pointer-events: auto;
	}
}

.k-case-tree-item-tile-outer-full-screen {
	position:fixed;
	z-index:199;
	left:12px;
	top:116px;
	// height:800px;
	margin-top:0;
	// max-height:calc(100vh - 128px);
	width:1080px;
	margin-left:calc(50vw - 540px);
	max-width:calc(100vw - 24px);

	.k-case-tree-item-tile {
		// max-height:100%;
		// max-height:800px;
		max-height:calc(100vh - 148px);
	}

	.k-big-table {
		th { font-size:0.8em; }
		td { font-size:0.8em; }
	}
}

.k-case-tree-item-tile-full-screen-history {
	position:fixed;
	z-index:199;
	left:12px;
	top:90px;
	margin-left:calc(50vw - 40px);

	width:80px;
	padding:4px 0;
	// height:24px;
	background-color:#fff;
	border-radius:8px;
	border:1px solid #ccc;
	text-align:center;
}

@media (max-width: 1104px) {
	.k-case-tree-item-tile-outer-full-screen {
		margin-left:0;
	}
}
</style>
